<section class="item-suppliers">
  <header class="item-suppliers-header">
    <strong class="item-suppliers-title">Fornecedores</strong>
    <span class="item-suppliers-summary">{{ summary() }}</span>
  </header>

  <ul class="item-suppliers-list">
    @for (supplier of data.suppliers; track supplier.id) {
      <li
        class="item-suppliers-item"
        [class.item-suppliers-item--pending]="supplier.pendingApproval">
        <mat-icon
          aria-hidden="true"
          [class.cotai-gradient-text]="supplier.fromCotai"
          >{{ supplier.fromCotai ? 'auto_awesome' : 'storefront' }}</mat-icon
        >
        <span class="item-suppliers-name">{{ supplier.name }}</span>
        <span class="item-suppliers-meta">
          @if (supplier.pendingApproval) {
            <span class="item-suppliers-tag">Sugestão pendente</span>
          }
          @if (supplier.sourceLabel) {
            <span>{{ supplier.sourceLabel }}</span>
          }
          @if (supplier.email) {
            <span class="item-suppliers-email">{{ supplier.email }}</span>
          }
        </span>
      </li>
    }
  </ul>

  @if (data.clickable) {
    <p class="item-suppliers-hint">Clique para adicionar ou gerenciar fornecedores.</p>
  }
</section>
